import { render, staticRenderFns } from "./PersonRepresentatives.vue?vue&type=template&id=1db6faad&scoped=true&"
import script from "./PersonRepresentatives.vue?vue&type=script&lang=js&"
export * from "./PersonRepresentatives.vue?vue&type=script&lang=js&"
import style0 from "./PersonRepresentatives.vue?vue&type=style&index=0&id=1db6faad&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db6faad",
  null
  
)

export default component.exports